export class AuthModel {
  authToken: string;

  setAuth(auth: string) {
    this.authToken = auth;
  }
}
